import React, { useEffect, useState } from 'react';
import { Api } from '@/api';
import { allRecordsPaginationOptions } from '@/infrastructure/const/pagination';
import { IReadSurah } from '@/infrastructure/interfaces/i-read-surah';

const api = Api.getInstance();

export interface IReadSurahSlugsContextType {
  getSurahSlugByNumber: (number: number) => string | undefined;
}

export const ReadSurahSlugsContext =
  React.createContext<IReadSurahSlugsContextType>({
    getSurahSlugByNumber: () => undefined,
  });

interface IReadSurahSlugsProvider {
  children?: React.ReactNode;
}

const ReadSurahSlugsProvider: React.FC<IReadSurahSlugsProvider> = ({
  children,
}) => {
  const [slugsByNumber, setSlugsByNumber] = useState<Map<number, string>>(
    new Map()
  );

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.getReadSurahs(allRecordsPaginationOptions, [
          'slug',
          'index',
        ]);
        const { results } = data;

        setSlugsByNumber(
          new Map(results.map((surah: IReadSurah) => [surah.index, surah.slug]))
        );
      } catch (error) {
        console.error(
          '[ReadSurahSlugsProvider] Failed to load surah slugs',
          error
        );
      }
    })();
  }, []);

  const getSurahSlugByNumber = (number: number): string | undefined =>
    slugsByNumber.get(number);

  return (
    <ReadSurahSlugsContext.Provider value={{ getSurahSlugByNumber }}>
      {children}
    </ReadSurahSlugsContext.Provider>
  );
};

export default ReadSurahSlugsProvider;
